import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { commonClass } from './component/helpers/commonClass';
import { loginActions } from './component/action/loginAction';
import { gameActions } from './component/action/GameAction';

class RouteRedirect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectTo: null,
    };
  }

  componentDidMount() {
    this.RedirectToHome();
  }

  GetCountry = async () => {
    try {
      const response = await commonClass.GetUserCountry();
      const data = await response.json();
      localStorage.setItem('cloc', JSON.stringify(data));
      return data;
    } catch (error) {
      if (localStorage.getItem('cloc')) {
        let df = JSON.parse(localStorage.getItem('cloc'));
        return df;
      }
      else {
        let df = { country: "IN" }
        localStorage.setItem('cloc', JSON.stringify(df));
        return df;
      }
    }
  };

  RedirectToHome = async () => {
    try {
      let countryData = { country: 'IN' }
      let Langname = '';
      if (localStorage.getItem('cloc') != null) {
        countryData = JSON.parse(localStorage.getItem('cloc'));
      }
      else {
        countryData = await this.GetCountry();
      }
      const storedLang = localStorage.getItem('language');
      if (storedLang) {
        Langname = JSON.parse(storedLang);
      } else {
        Langname = this.getCookie('gtlang');
      }
      // Location based country set work pending 20.05.2025 
      // let GetValue = commonClass.setCurrencyByPlayerLoc()
      // if (GetValue) {
      //   this.props.SetUserCurrency(GetValue)
      // }
      const searchname = window.location.search;
      let path = '/home'
      if (countryData && countryData.country && countryData.country.toLowerCase() == 'my') {
        path = `/${countryData.country}-${Langname}/lottery-ticket${searchname}`;
      }
      else {
        //  path = `/${countryData.country}-${Langname}/home${searchname}`;
        path = `/${countryData.country}-${Langname}/big-ticket${searchname}`;

      }
      this.state.redirectTo = path;
      this.setState({ redirectTo: path });
    } catch (error) {
      let countryData = { country: 'IN' }
      return countryData;
    }
  };

  getCookie = (name) => {
    try {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      let lang_val = process.env.REACT_APP_DEFAULTLANGUAGE;
      if (parts.length >= 2) {
        let lst = value.split(`;`);
        let fobj = lst.filter(a => a.indexOf('gtlang=') >= 0);
        if (fobj && fobj.length > 0) {
          let fobj1 = fobj[fobj.length - 1].split(`=`);
          lang_val = fobj1[1];
        }
      }
      return lang_val;
    }
    catch (ex) {
      return process.env.REACT_APP_DEFAULT_LANGUAGE;
    }
  };

  render() {
    const { redirectTo } = this.state;

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }

    return <div>Loading or doing initial setup...</div>;
  }
}



function mapStateToProps(state) {
  return {};
}
const mapActionToProps = {
  SetUserCurrency: loginActions.SetUserCurrency
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(RouteRedirect))